module.exports = __webpack_public_path__ + "img/ten.ca11f84a.svg";